export const userSettings = {
  priceClick: [`alert`, `order`],
  zeroStyle: [`gray`, `white`, `none`],
  depthStyle: [`redgreen`, `blue`, `none`]
};
